import type {
  CartFeedingPlanDto,
  CartFeedingPlanProductDto,
  CartSkuDto,
} from './schemas'
import { initContract } from '@ts-rest/core'
import z from 'zod'
import { ErrorResponseSchema, Identifier } from '../../shared/types'
import {
  UpdateCartFeedingPlanBodySchema,
  UpsertCartSkuBodySchema,
} from './schemas'

const c = initContract()

const options = {
  pathPrefix: '/plans',
  commonResponses: {
    400: ErrorResponseSchema,
    404: ErrorResponseSchema,
    500: ErrorResponseSchema,
  },
}

export const cartPlansContract = c.router({
  getPlan: {
    method: 'GET',
    path: '/:planId',
    pathParams: z.object({
      planId: Identifier,
    }),
    responses: {
      200: c.type<CartFeedingPlanDto>(),
    },
  },

  updatePlan: {
    method: 'PATCH',
    path: '/:planId',
    pathParams: z.object({
      planId: Identifier,
    }),
    body: UpdateCartFeedingPlanBodySchema,
    responses: {
      200: c.type<CartFeedingPlanDto>(),
    },
  },

  deletePlan: {
    method: 'DELETE',
    path: '/:planId',
    pathParams: z.object({
      planId: Identifier,
    }),
    responses: {
      204: c.type<null>(),
    },
  },

  upsertProductToPlan: {
    method: 'PUT',
    path: '/:planId/products/:productId',
    pathParams: z.object({
      planId: Identifier,
      productId: Identifier,
    }),
    body: c.noBody(),
    responses: {
      200: c.type<CartFeedingPlanProductDto>(),
    },
  },

  removeProductFromPlan: {
    method: 'DELETE',
    path: '/:planId/products/:productId',
    pathParams: z.object({
      planId: Identifier,
      productId: Identifier,
    }),
    responses: {
      204: c.noBody(),
    },
  },

  upsertSkuToPlan: {
    method: 'PUT',
    path: '/:planId/skus/:productVariantId',
    pathParams: z.object({
      planId: Identifier,
      productVariantId: Identifier,
    }),
    body: UpsertCartSkuBodySchema,
    responses: {
      200: c.type<CartSkuDto>(),
    },
  },

  removeSkuFromPlan: {
    method: 'DELETE',
    path: '/:planId/skus/:productVariantId',
    pathParams: z.object({
      planId: Identifier,
      productVariantId: Identifier,
    }),
    responses: {
      204: c.noBody(),
    },
  },
}, options)
